import axios from "axios"
import { API_BASE_URL } from "../../../config/apiConfig"

const getAllProduct = async () => {
    const response = await axios.get(`${API_BASE_URL}/product/`)
    console.log("Products", response.data);
    if (response.data) {
        return response.data
    }
}

const getProduct = async (reqData) => {
    const { productId } = reqData
    const response = await axios.get(`${API_BASE_URL}/product/${productId}`)
    console.log("Product Details", response.data);
    if (response.data) {
        return response.data
    }
}

export const productService = {
    getAllProduct,
    getProduct,
}
